import { Button, Check, X } from "@repo/ui";

type Props = {
  fieldId: number;
  handleSaveClick: (fieldId: number) => void;
  handleCancelClick: () => void;
};

export const SaveCancelActions = ({ handleSaveClick, handleCancelClick, fieldId }: Props) => {
  return (
    <>
      <Button
        data-allow-navigation
        onClick={() => handleSaveClick(fieldId)}
        variant="ghost"
        icon={<Check className="h-4 w-4 text-green-600" />}
        title="Save"
      />
      <Button
        data-allow-navigation
        onClick={handleCancelClick}
        variant="ghost"
        icon={<X className="h-4 w-4 text-red-600" />}
        title="Cancel"
      />
    </>
  );
};
